module.exports = __webpack_public_path__ + "img/logo9.8fee96ba.png";